// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "footer__button-2vihw";
var _3 = "footer__price-3Q8ts";
var _4 = "footer_selected-2qKI8";
export { _1 as "__esModule", _2 as "footer__button", _3 as "footer__price", _4 as "footer_selected" }
export default { "__esModule": _1, "footer__button": _2, "footer__price": _3, "footer_selected": _4 }
